import { STEPS } from '@constant/steps';
import { useCurrentStep } from '@context/MainContext';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Link, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
	modalContentFont: {
		color: theme.surfaceVariants.primary.onSurface,
		textAlign: 'left'
	},
	ul: {
		margin: 0,
		paddingLeft: '1.25rem'
	}
}));

export const TransactionDetailsModalHeader = (props) => {
	const { closeModal } = props || {};
	const theme = useTheme();
	const { t } = useTranslation();
	const currentStep = useCurrentStep();

	const getHeader = () => {
		switch (currentStep) {
			case STEPS.IN_TRANSIT:
				return t('WHEN_WILL_MY_MONEY_ARRIVE');
			case STEPS.COMPLETED:
				return t('MONEY_NOT_IN_ACCOUNT_YET');
			default:
				return null;
		}
	};

	return (
		<>
			<Typography variant="h3" sx={{ display: 'flex', height: '40px', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
				<IconButton
					onClick={closeModal}
					sx={{
						position: 'absolute',
						right: 24,
						top: 24,
						color: theme.surfaceVariants.primary.onSurface,
						'&:hover': {
							backgroundColor: 'transparent'
						}
					}}>
					<CloseIcon />
				</IconButton>
			</Typography>
			<Typography variant="h3" pb={2}>
				{getHeader()}
			</Typography>
		</>
	);
};

export const FundArrivalEnquiryModal = () => {
	const { t } = useTranslation();
	const { classes } = useStyles();

	return (
		<Stack className={classes.modalContentFont} direction={'column'} alignItems={'flex-start'} gap={2}>
			<Typography variant="h5">{t('STANDARD_PROCESSING_TIME')}</Typography>
			<Typography variant="h5">
				<ul className={classes.ul}>
					<li>{t('TRANSFER_DURATION')}</li>
				</ul>
			</Typography>
			<Typography variant="h5">{t('TRANSFER_EXCEPTION_DURATION')}</Typography>
			<Typography variant="h5">
				<ul className={classes.ul}>
					<li>{t('RECIPIENT_BANK_VALIDATION')}</li>
					<li>{t('COMPLIANCE_CHECKS')}</li>
					<li>{t('BANK_HOLIDAYS_AND_WEEKENDS')}</li>
				</ul>
			</Typography>
			<Typography variant="h5">
				{t('FURTHER_ENQUIRIES_PREFIX')}{' '}
				<Link
					href="https://support.moneymatch.co/hc/en-us/articles/360039352051-How-long-will-it-take-for-my-money-to-reach-the-recipient-bank-account"
					target="_blank"
					sx={{ color: 'inherit', textDecoration: 'underline' }}>
					{t('FURTHER_ENQUIRIES_LINK')}
				</Link>{' '}
				{t('FURTHER_ENQUIRIES_SUFFIX')}
			</Typography>
		</Stack>
	);
};

export const MoneyNotYetReceivedModal = () => {
	const { t } = useTranslation();
	const { classes } = useStyles();

	return (
		<Stack className={classes.modalContentFont} direction={'column'} alignItems={'flex-start'} gap={2}>
			<Typography variant="h5">{t('FUND_NOT_YET_RECEIVED_REASON')}</Typography>
			<Typography variant="h5">
				<ul className={classes.ul}>
					<li>{t('ADDITIONAL_SECURITY_CHECKS')}</li>
					<li>{t('LIMITED_PROCESSING_SCHEDULES')}</li>
					<li>{t('CLOSURES_DUE_TO_PUBLIC_HOLIDAYS')}</li>
				</ul>
			</Typography>
			<Typography variant="h5">{t('FUND_NOT_YET_RECEIVED_ASSISTANCE')}</Typography>
		</Stack>
	);
};

export const TransactionDetailsModalContent = () => {
	const currentStep = useCurrentStep();

	const renderContent = () => {
		switch (currentStep) {
			case STEPS.IN_TRANSIT:
				return <FundArrivalEnquiryModal />;
			case STEPS.COMPLETED:
				return <MoneyNotYetReceivedModal />;
			default:
				return null;
		}
	};

	return renderContent();
};
